module.exports = __webpack_public_path__ + "img/04.6a426f0c.png";